import React from 'react';
import { ClientWebEmbeddingMessageType } from '@cp/common/clientWebEmbedding';
import { useDispatch, useSelector } from 'react-redux';
import { useModalPromise } from '@cp/shared/modal';
import { Result } from '@cp/shared/result';
import { UXSlice, notificationsSubscribeReminderLastShownInMsSelector } from 'src/shared/ux';
import { embeddingPushNotificationsSubscribedSelector, useEmbedding } from 'src/shared/embedding';
import { useTracking } from 'src/shared/tracking';
import { SUBSCRIBE_MODAL, notificationEnabled } from '../lib';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const REMINDER_FREQ_IN_MS = 24 * 60 * 60 * 1000;

export interface NotificationsSubscribeReminderProps {}
export const NotificationsSubscribeReminder: React.FC<NotificationsSubscribeReminderProps> = () => {
  const dispatch = useDispatch();
  const lastShownInMs = useSelector(notificationsSubscribeReminderLastShownInMsSelector);
  const isPushNotificationsSubscribed = useSelector(embeddingPushNotificationsSubscribedSelector);
  const { postMessage } = useEmbedding();
  const openSubscribeModal = useModalPromise(SUBSCRIBE_MODAL);
  const trackEnabled = useTracking(notificationEnabled);

  React.useEffect(() => {
    if (isPushNotificationsSubscribed !== false) {
      return;
    }

    const currentTimeInMs = Date.now();
    const timeoutId = setTimeout(
      () => {
        dispatch(UXSlice.actions.setNotificationsSubscribeReminderLastShownInMs());
        Result.fromAsync(() => openSubscribeModal({})).then((modalResult) => {
          modalResult.tap(() => {
            postMessage({ type: ClientWebEmbeddingMessageType.RequestPushNotificationsSubscribing });
            trackEnabled();
          });
        });
      },
      lastShownInMs ? Math.max(lastShownInMs + REMINDER_FREQ_IN_MS - currentTimeInMs, 0) : 0,
    );
    return () => {
      clearTimeout(timeoutId);
    };
  }, [dispatch, isPushNotificationsSubscribed, lastShownInMs, openSubscribeModal, postMessage, trackEnabled]);

  return null;
};
